export default "__VITE_ASSET__M2ZF20bb__"